import { Component, OnInit, EventEmitter, Output, Input, SimpleChanges } from '@angular/core';
/*App imports*/
import { HelpersService } from '../../../../services/tools/helpers.service';
import { ReportsHelperService } from '../../../../services/tools/reports-helpers.service';
import { CreditosService } from "../../../../services/creditos.service";
import { ConveniosService } from "../../../../services/convenios.service";
import { SucursalesService } from '../../../../services/sucursales.service';

@Component({
    selector: 'colocados-filtros',
    templateUrl: './colocados-filtros.component.html'
  })

export class ColocadosFiltrosComponent implements OnInit {
    @Output() public onFilterChange : EventEmitter<Object> = new EventEmitter;
    @Input() public activeReport : string = null;

    public errors: any = {};
    public fechaInicio: string = null;
    public fechaFin: string = null;
    
    public sucursales: any[] = [];
    public sucursal: any = {id:null};
    public sucursalPorDefecto: string = "";
    // General
    public tiposCreditos: object = [];
    public selectedTipoCredito: string = '';
    // Verde
    public proveedorSelected: string = null;
    // Personal
    public avalSelected: string = null;
    // Nomina
    public convenioSelected: string = '';
    public convenios: any[] = [];
    // Carburación
    public unidadSelected: string = '';
    // Estacionarios
    public plantaSelected: string = null;
    public giroSelected: string = null;

    constructor(
        private helperService: HelpersService,
        private helpersReportsService: ReportsHelperService,
        private creditosService: CreditosService,
        private sucursalesService : SucursalesService,
        private conveniosService: ConveniosService
    ){
    }

    public ngOnInit() {
    }

    public ngOnChanges(changes: SimpleChanges) {        
        if(changes.activeReport && this.activeReport){
            this.setupFilters(this.activeReport);
        }
    }

    private setupFilters(activeReport: string){
        
        switch(activeReport){
            case 'general':
                this.getTiposCreditos();
                break
            case 'nomina':
                this.getConvenios();
                break
        }
        this.getSucursales();
    }

    private setupDefaultState() {
        let defaultDates = this.helpersReportsService.getDefaultDates();
        this.fechaInicio = defaultDates.fechaInicio;
        this.fechaFin = defaultDates.fechaFin;

        let filters = {
            fechaInicio: this.fechaInicio,
            fechaFin: this.fechaFin,
            sucursal : this.sucursal.id
        };

        this.onFilterChange.emit(filters);
    }

    public filterChange(){
        let filters: any = {
            fechaInicio: this.fechaInicio,
            fechaFin: this.fechaFin,
            sucursal : this.sucursal.id
        };

        switch(this.activeReport){
            case 'general':
                filters.tipoCredito = this.selectedTipoCredito
                break;
            case 'verde':
                filters.proveedor = this.proveedorSelected;
                break;
            case 'personal':
                filters.aval = this.avalSelected;
                break;
            case 'nomina':
                filters.convenio = this.convenioSelected;
                break;
            case 'carburacion':
                filters.usoUnidad = this.unidadSelected;
                break;
            case 'estacionario':
                filters.planta = this.plantaSelected;
                filters.giro = this.giroSelected;
                break;
        }

        this.onFilterChange.emit(filters);
    }

    private getSucursales(){
        this.sucursalesService.get().subscribe(
          (response)=>
          {
            const jsonResult = response.json();
            if(jsonResult.content){
              this.sucursales = jsonResult.content.data;
              if (this.sucursales.length>1){
                this.sucursalPorDefecto = "Seleccione";
              } else if(this.sucursales.length>0){
                this.sucursal =  this.sucursales[0];
              }
            }
            this.setupDefaultState();
            
          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
    
            if(error.status == 400) {
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }
    
    sucursalChanged(sucursal){
        if(sucursal){
        this.sucursal = sucursal;
        this.filterChange();
        }
    }

    private getTiposCreditos(){
        this.creditosService.getTiposCreditos().subscribe(
            (response)=>
            {
                const jsonResult = response.json();
                if(jsonResult.content){
                    this.tiposCreditos = jsonResult.content;
            }
            
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    //Reporte de nomina
    public getConvenios(){    
        this.conveniosService.getAll({ paginate : false, order : 'razon_social' }).subscribe(
            (response)=>
            {
            const jsonResult = response.json();
            if(jsonResult.content){
                this.convenios = response.json().content;
            }
            
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/reportes/creditos-colocados/components/filtros/colocados-filtros.component.ts